import React from 'react';
import { useAddEpicGroupMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddEpicGroupDto, ProjectDto } from '@/core';
import { EpicGroupForm } from './EpicGroupForm';
import { EpicGroupTypesEnum, FormValueType } from './hooks';

const getInitialValue = (): FormValueType => ({
  type: EpicGroupTypesEnum.Products,
  name: '',
  epics: undefined,
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddEpicGroupForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-epic-group');
  const [addEpicGroup] = useAddEpicGroupMutation();
  const initialValue = getInitialValue();

  const handleSubmit = (epicGroupData: AddEpicGroupDto) => {
    addEpicGroup({ epicGroupData, projectId: projectData.id })
      .unwrap()
      .then(() => form.current?.setValues({ type: epicGroupData.type, name: '', epics: [] }, false));
  };

  return (
    <EpicGroupForm
      handleSubmit={handleSubmit}
      projectData={projectData}
      formUid="add-epic-group"
      initialValue={initialValue}
      epicType={EpicGroupTypesEnum.Products}
    />
  );
};
